import React from 'react';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <p>Mi propósito es ayudarte a vivir una maternidad plena, organizada y feliz.</p>
        <div className="footer-links">
          <a href="/">Política de Privacidad</a>
          <a href="/">Términos y Condiciones</a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer">Instagram</a>
          <a href="https://facebook.com" target="_blank" rel="noreferrer">Facebook</a>
          <a href="https://linkedin.com" target="_blank" rel="noreferrer">LinkedIn</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
